import { px } from "@certn/cascadia";
import { useColors } from "@certn/cascadia-react";
import { shapes, sizes, textStyles, weights } from "@certn/cascadia-tokens";
import { Elements } from "@stripe/react-stripe-js";

type ElementsProps = React.ComponentProps<typeof Elements>;
type StripeAppearance = NonNullable<ElementsProps["options"]>["appearance"];

export function useStripeAppearance(): StripeAppearance {
  const colors = useColors();

  const labelValues = textStyles["input/label"];
  const inputValues = textStyles["input/text-field"];

  return {
    theme: "stripe",

    variables: {
      colorPrimary: colors["border-input-active"],
      colorBackground: colors["background-input"],
      colorText: colors["text-base"],
      colorDanger: colors["text-danger"],
      fontFamily: `"IBM Plex Sans", "sans-serif"`,
      gridRowSpacing: px("space-3") + "px",
      gridColumnSpacing: px("space-3") + "px",
      borderRadius: shapes["border-radius-2"] + "px",
      fontSizeSm: sizes[labelValues.size].px + "px",
    },

    rules: {
      ".Label": {
        size: sizes[labelValues.size] + "px",
        fontWeight: weights[labelValues.weight],
      },
      ".Input": {
        border: `1px solid ${colors["border-input"]}`,
        size: sizes[inputValues.size] + "px",
        fontWeight: weights[inputValues.weight],
      },
    },
  };
}
